export const API_URL = `${process.env.REACT_APP_STORE_URL}/api/meta-store`
export const MEDTRYCK_API_URL = `${process.env.REACT_APP_MEDTRYCK_API_URL}/api/meta-store`
